import state from '~store/modules/lawsuits/state'
import actions from '~store/modules/lawsuits/actions'

export default {
  state,
  actions
}
